import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FileUploader } from "react-drag-drop-files";
import { Modal, Button } from "react-bootstrap";
import { FormSelect } from "../../../../../Components/Buttons/FormSelect/FormSelect";
import { FormInput } from "../../../../../Components";
import { hasValue } from "../../../../../Helpers/validations/common";
import "./AddSchoolFlowModal.scss";

export function AddSchoolFlowModal({ allSchools, error, submit, ...props }) {
  const [t] = useTranslation();
  const [schoolSelected, setSchoolSelected] = useState(allSchools[0]);
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [haveThirdFlow, setHaveThirdFlow] = useState(false);
  const [file, setFile] = useState(null);

  return (
    <Modal {...props} centered dialogClassName="add-school-flow-modal">
      <Modal.Header className="add-school-flow-header" closeButton>
        <div className="title">{t("AddSchoolFlow")}</div>
      </Modal.Header>
      <Modal.Body className="add-school-flow-content">
        <div className="field-wrapper">
          <div className="label">{t("School")}</div>
          <FormSelect
            placeholder={t("School")}
            type="text"
            options={allSchools}
            value={schoolSelected}
            change={(x) => setSchoolSelected(x)}
          />
        </div>
        <div className="field-wrapper">
          <div className="label">{t("Year")}</div>
          <FormInput
            placeholder={t("Year")}
            type="number"
            value={year}
            otherProperties={{
              step: 1,
            }}
            change={(x) => {
              if (x > 2000 && x < 2100) {
                setYear(x);
              }
            }}
          />
        </div>
        <div
          className="third-flow-check-wrapper"
          onClick={() => setHaveThirdFlow(!haveThirdFlow)}
        >
          <div className="checkbox">
            {haveThirdFlow ? "check_box" : "check_box_outline_blank"}
          </div>
          <div className="label">{t("HaveThirdFlow")}</div>
        </div>
        {haveThirdFlow && (
          <FileUploader
            className="importOverviewPage-carrousel-1-inputFile"
            handleChange={(x) => setFile(x)}
            name="file"
            types={["csv"]}
          />
        )}
        {hasValue(error) && <div className="error-wrapper">{t(error)}</div>}
        <div className="button-wrapper">
          <Button className="button-cancel" onClick={() => props.onHide()}>
            {t("Cancel")}
          </Button>
          <Button
            className="button"
            onClick={() => {
              submit({
                HaveThirdScan: haveThirdFlow,
                Year: parseInt(year),
                SchoolId: schoolSelected.hasOwnProperty("id")
                  ? schoolSelected.id
                  : schoolSelected,
                file: haveThirdFlow ? file : null,
              });
            }}
          >
            {t("Add")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
